import { render } from "./Clipbord.vue?vue&type=template&id=2aace69a"
import script from "./Clipbord.vue?vue&type=script&lang=js"
export * from "./Clipbord.vue?vue&type=script&lang=js"

import "./Clipbord.vue?vue&type=style&index=0&id=2aace69a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__